import { Row, Col, Typography, Flex } from 'antd'
import { useUserNewsletter } from '../../hooks/useUserNewsletter'
import BackButton from '../../components/elements/BackButton'
import ContentCard from '../../components/layouts/ContentCard'
import NewsletterCategoriesForm from './components/NewsletterCategoriesForm'
import { HelmetHeader } from '../../components/elements/HelmetHeader'

export default function NewsletterPreferences() {
  const userNewsletter = useUserNewsletter()

  return (
    <Row className="bg bg5" justify="center">
      <HelmetHeader />
      <Col align="middle" flex="724px">
        <ContentCard
          loading={userNewsletter.isLoading}
          title={
            <Flex>
              <BackButton />
            </Flex>
          }
        >
          <Row gutter={[24, 24]}>
            <Col flex="600px">
              <Typography.Title level={3} style={{ marginBottom: 12 }}>
                <span>{'איזה ענפי ספורט מעניינים אותך?'}</span>
                <br />
                <span>{'(בחירה מרובה)'}</span>
              </Typography.Title>
              <Typography.Paragraph>
                {
                  'חשוב לנו לוודא שאנחנו שולחים את הכתבות הרלוונטיות ביותר עבורך. לכן, נשמח לקבל ממך קצת הכוונה! איזה כתבות היית רוצה לקבל מאיתנו בעיקר?'
                }
              </Typography.Paragraph>
            </Col>
            <Col xs={24}>
              <NewsletterCategoriesForm submitText="שמירה" postSubmitRedirectUrl="/newsletter/complete" />
            </Col>
          </Row>
        </ContentCard>
      </Col>
    </Row>
  )
}
